import { UpdateRuntimeforLabelandUrlChange } from "../../API/Runtime/RuntimeHelper";
import { UploadFiletoDirectory } from "../Helpers/DateLakeStorage";

export async function uploadFiles(files, organizationId, projectId) {
    const formData = new FormData();

    const map = new Map(files.map(item => [item["name"], item]));
    const mapValues = map.values();
    const filesToUpload = [...mapValues];

    for (const file of filesToUpload) {
        if (!file.validationErrors) {
            const fileName = (
                file.name.split('.').slice(0, -1).join('.').replace(/[^a-zA-Z0-9]/g, "") +
                new Date().getTime() +
                file.extension
            );
            formData.append(`file`, file.getRawFile(), fileName);
        }
    }

    let path = `${organizationId}/${projectId}/ProjectImages`;
    formData.append("path", path);

    const uploadResponse = await UploadFiletoDirectory(formData);

    return uploadResponse;
}

export async function updateProjectLabelAndUrlOnRuntime(organizationId, projectUrl, projectName, context, instances) {
    for (const instance of instances) {
        if (instance.Published) {
            const instanceId = instance._id;
            const updatedUrl = projectUrl + "_" + instanceId.slice(0, 5);
            const data = {
                updatedUrl,
                updatedLabel: projectName
            };
            try {
                await UpdateRuntimeforLabelandUrlChange(
                    "Application", context, organizationId, instanceId, null, data
                )
            } catch (e) {
                return ["error", {
                    instance: instance,
                    message: "Something went wrong while updating label on runtime for instance " + instance.instanceType
                }];
            }
        }
    }

    return ["success", "Updated labels and url on runtime"];
}